// extracted by mini-css-extract-plugin
module.exports = {"neighborhoodContainer":"styles_neighborhoodContainer__zq4MQ","container":"styles_container__JWWM5","title":"styles_title__VqV_G","map":"styles_map__K5Q2Z"};